import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

import {
    OnChangeInputType,
    CheckboxChangeEvent,
} from '@pluto/@types';
import Table, {
    SetPage,
    SetRowsPerPage,
    Sort,
} from '@pluto/table';
import {UsersState} from '@pluto/users';
import UserColumns from './UserListColumns';
import {UserListFilters} from './UsersListTypes';
import UserFiltersList from './UserFiltersList';

import './UsersList.scss';
import UsersToolbar from './UsersToolbar';

interface UsersListProps {
    users: UsersState;
    setSort: () => void;
    sort: Sort;
    onPaging: () => void;
    page: number;
    setPage: SetPage;
    rowsPerPage: number;
    setRowsPerPage: SetRowsPerPage;
    name: string;
    onSearch: OnChangeInputType;
    onRolesFilter: CheckboxChangeEvent;
    onStatusFilter: CheckboxChangeEvent;
    filters: UserListFilters;
}

export default function UsersList(props: UsersListProps) {
    const {
        users,
        setSort,
        sort,
        onPaging,
        page,
        setPage,
        rowsPerPage,
        setRowsPerPage,
        name,
        onSearch,
        onRolesFilter,
        onStatusFilter,
        filters,
    } = props;

    return (
        <Box>
            <Typography
                variant="h5"
                className="users-list__heading"
            >
                Manage Users
            </Typography>
            <UsersToolbar
                name={name}
                onSearch={onSearch}
            />
            <UserFiltersList
                onRolesFilter={onRolesFilter}
                onStatusFilter={onStatusFilter}
                filters={filters}
            />
            <Table
                data={users.rows}
                columns={UserColumns}
                setSort={setSort}
                sort={sort}
                total={users.total}
                onChangePageHandler={onPaging}
                page={page}
                setPage={setPage}
                rowsPerPage={rowsPerPage}
                setRowsPerPage={setRowsPerPage}
            />
        </Box>
    );
}
